import React, { useEffect, useRef, useState } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, useMediaQuery } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { checkNotificationStatus, updateFilteredData } from '../../../Store/DashboardSlice/DashboardSlice';
import CrossCircle from '../../../Assets/Images/close-circle.svg';
import { getNotificationSocket } from '../../../Services/SocketIOConfig';
import { SocketEvents } from '../../../Assets/Constants/SocketString';
import NotificationItem from './NotificationItem';
let socket;

const NotificationDailog = ({ open, onClose }) => {
  const dispatch = useDispatch();
  const { hiddenNotifications, filteredData } = useSelector(state => state.dashboard);
  const { accessToken } = useSelector(state => state.auth);
  const { userInfo } = useSelector(state => state.auth);
  const [page, setPage] = useState(1);
  const containerRef = useRef(null);
  const isMobile = useMediaQuery('(max-width:600px)');
  const [authToken, setAuthToken] = useState(localStorage.getItem('authToken'));

  useEffect(() => {
    setAuthToken(accessToken ? accessToken : localStorage.getItem('authToken'));
  }, [accessToken]);

  // useEffect(() => {
  //   socket = getNotificationSocket(authToken);

  //   socket.on(SocketEvents.Connect, () => {
  //     socket.emit('mark_as_read', {
  //       notificationUserId: userInfo.userId
  //     });
  //   });

  //   socket.on(SocketEvents.NewNotification, data => dispatch(updateFilteredData(data)));

  //   socket.on(SocketEvents.Notifications, data => {
  //     if (data.page === 1) {
  //       const visibleData = data?.notifications?.filter(
  //         notification => !hiddenNotifications.includes(notification.notificationId)
  //       );

  //       dispatch(updateFilteredData(visibleData));

  //       if (visibleData?.length === 0) dispatch(checkNotificationStatus(true));
  //       else dispatch(checkNotificationStatus(false));
  //     }
  //     if (data?.notifications.length > 0) setPage(prevPages => prevPages + 1);
  //   });

  //   socket.on(SocketEvents.Disconnect, () => {
  //     console.log('Disconnected from WebSocket server');
  //   });

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [hiddenNotifications, userInfo, authToken]);

  const handleSetShow = () => {
    setPage(1);
    onClose();
  };

  const handleScroll = () => {
    const container = containerRef.current;
    if (container && container.scrollTop > 0) {
      const isAtBottom = container.scrollHeight - container.scrollTop <= container.clientHeight;
      if (isAtBottom) {
        const additionalParams = { page: page, limit: 30 };
        socket.emit(SocketEvents.GetNotifications, additionalParams);
        socket.on(SocketEvents.Notifications, data => {
          if (data.page >= 2 && data.notifications && data.notifications.length > 0) {
            const newData = filteredData.concat(data.notifications);
            dispatch(updateFilteredData(newData));
          }
        });
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleSetShow}
      PaperProps={{ style: { width: isMobile ? '312px' : '406px', borderRadius: '8px' } }}
    >
      <DialogTitle display={'flex'} justifyContent={'space-between'}>
        <div className='medium4'>Notifications</div>
        <img src={CrossCircle} onClick={handleSetShow} style={{ cursor: 'pointer' }} />
      </DialogTitle>
      <DialogContent ref={containerRef} onScroll={handleScroll}>
        <NotificationItem filteredData={filteredData} />
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};

export default NotificationDailog;
